(function () {
  'use strict';
  if (window.__drLpInit) return;
  window.__drLpInit = true;

  function initFaq(root) {
    if (!root || root.dataset.drFaqInit === '1') return;
    root.dataset.drFaqInit = '1';
    var items = root.querySelectorAll('.dr-lp__faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.dr-lp__faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initSticky(bar) {
    if (!bar || bar.dataset.drStickyInit === '1') return;
    bar.dataset.drStickyInit = '1';
    var hero = document.querySelector('.dr-lp__hero');
    function update() {
      if (!hero) { bar.classList.add('is-visible'); return; }
      var heroBottom = hero.getBoundingClientRect().bottom;
      bar.classList.toggle('is-visible', heroBottom < 0);
    }
    document.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // AJAX add-to-cart: intercept any form[action="/cart/add"] inside .dr-lp,
  // POST to /cart/add.js, then trigger the theme's side cart drawer.
  function doAjaxAdd(form) {
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      if (window.$s && typeof window.$s.addToCartSuccess === 'function') {
        window.$s.addToCartSuccess();
      } else if (window.SideCart && typeof window.SideCart.updateSideCart === 'function') {
        window.SideCart.updateSideCart(true);
      } else {
        location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch(function (err) {
      var msg = (err && err.description) || 'Could not add to cart.';
      if (window.$s && typeof window.$s.addToCartFail === 'function') {
        window.$s.addToCartFail(msg);
      } else {
        alert(msg);
      }
    })
    .finally(function () {
      if (btn) btn.removeAttribute('disabled');
    });
  }

  function initAjaxAtc() {
    var handler = function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!form.closest('.dr-lp')) return;
      e.preventDefault();
      e.stopPropagation();
      doAjaxAdd(form);
    };

    // Capture phase fires before any bubble-phase handler can interfere.
    document.addEventListener('submit', handler, true);

    // Also attach directly to each form as a redundant safety net.
    document.querySelectorAll('.dr-lp form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.drAtcInit === '1') return;
      form.dataset.drAtcInit = '1';
      form.addEventListener('submit', handler);
    });
  }

  function init() {
    document.querySelectorAll('[data-dr-faq]').forEach(initFaq);
    document.querySelectorAll('[data-dr-sticky]').forEach(initSticky);
    initAjaxAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
